import React, { useEffect, useState } from "react";
import useDarkMode from "../../hooks/useDarkMode";

const LoadingSVG = ({ height = 25, color }) => {
  const [isAnimating, setIsAnimating] = useState(true);
  
  useEffect(() => {
    // Keep animation state true while component is mounted
    return () => setIsAnimating(false);
  }, []);

  // Calculate dimensions based on the height prop
  const barWidth = Math.max(3, height * 0.12);
  const barMargin = Math.max(4, height * 0.16);
  const barRadius = Math.max(2, height * 0.08);
  const totalWidth = (barWidth * 5) + (barMargin * 4);
  
  return (
    <svg 
      width={totalWidth} 
      height={height} 
      viewBox={`0 0 ${totalWidth} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {[0, 1, 2, 3, 4].map((index) => {
        const delay = index * 0.15;
        const x = index * (barWidth + barMargin);
        
        return (
          <rect
            key={index}
            x={x}
            y={0}
            rx={barRadius}
            ry={barRadius}
            width={barWidth}
            height={height}
            fill={color}
          >
            <animate
              attributeName="height"
              attributeType="XML"
              values={`${height * 0.4};${height};${height * 0.4}`}
              dur="1s"
              repeatCount="indefinite"
              begin={`${delay}s`}
            />
            <animate
              attributeName="y"
              attributeType="XML"
              values={`${height * 0.6};0;${height * 0.6}`}
              dur="1s"
              repeatCount="indefinite"
              begin={`${delay}s`}
            />
          </rect>
        );
      })}
    </svg>
  );
};

const Loading = ({ loading, className, message = "Please wait...", height = 25 }) => {
  const darkMode = useDarkMode();
  
  // Define the color based on dark mode
  const loaderColor = darkMode === 'dark' ? "#ffffff" : "#091d8f";
  
  // Dynamic gradient colors for the text based on dark mode
  const textGradientClass = darkMode === 'dark' 
    ? "bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent" 
    : "bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent";

  return (
    <div className={`text-lg text-center ${loading ? className : ''}`}>
      {loading && (
        <div className="flex flex-col items-center">
          <div className="mb-3">
            <LoadingSVG height={height} color={loaderColor} />
          </div>
          <p className={`text-sm font-medium ${textGradientClass}`}>{message}</p>
        </div>
      )}
    </div>
  );
};

export default Loading;